import React from "react";
import { 
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Loader2 } from "lucide-react";

interface DeleteAdDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onDelete: () => void;
  selectedAd: any;
  isDeleting: boolean;
}

const DeleteAdDialog: React.FC<DeleteAdDialogProps> = ({
  isOpen,
  onOpenChange,
  onDelete,
  selectedAd,
  isDeleting
}) => {
  return (
    <AlertDialog open={isOpen} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>¿Eliminar anuncio permanentemente?</AlertDialogTitle>
          <AlertDialogDescription className="space-y-2">
            <p>
              Esta acción eliminará permanentemente el anuncio
              {selectedAd && ` "${selectedAd.clientName}"`} y no se puede deshacer.
            </p>
            <p>
              Se eliminarán:
            </p>
            <ul className="list-disc list-inside text-sm">
              <li>El anuncio y toda su información</li>
              <li>Los materiales asociados al anuncio</li>
              <li>Las referencias en las pantallas</li>
              <li>Las referencias en facturas</li>
            </ul>
            <p className="text-red-600 font-medium mt-2">
              ⚠️ Esta acción es irreversible y los datos no se podrán recuperar.
            </p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isDeleting}>Cancelar</AlertDialogCancel>
          <AlertDialogAction 
            onClick={onDelete} 
            className="bg-red-500 hover:bg-red-600 gap-2"
            disabled={isDeleting}
          >
            {isDeleting && <Loader2 className="h-4 w-4 animate-spin" />}
            {isDeleting ? "Eliminando..." : "Sí, eliminar permanentemente"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteAdDialog;
